import React from "react";
import { QrCode, Printer } from "lucide-react";
import { qrTestPayload } from "../../../../tests/qztray/qrTestPayload";
import { BackendQzPayloadAdapter } from "../../../../utils/qztray/BackendQzPayloadAdapter";

interface Props {
  connectClient: Function;
  discoverPrinters: Function;
  print: Function;
  isConnected: boolean;
  printer: string;
  setPrinter: (p: string) => void;
  setPrinters: (list: string[]) => void;
  printers: string[];
  isLoading: boolean;
  setIsLoading: (b: boolean) => void;
}

const PrintQrSection: React.FC<Props> = ({
  connectClient,
  discoverPrinters,
  print,
  isConnected,
  printer,
  setPrinter,
  setPrinters,
  isLoading,
  setIsLoading,
}) => {

  // 🔍 Obtener impresoras disponibles
  const handleDiscoverPrinters = async () => {
    try {
      setIsLoading(true);
      await connectClient();
      const list = await discoverPrinters();

      setPrinters(list);
      const rptPrinter = list.find((p) => p.includes("RPT004"));
      const selected = rptPrinter || list[0];
      setPrinter(selected);
    } catch (err) {
      console.error("❌ Error al descubrir impresoras:", err);
      alert("No se pudieron obtener impresoras.");
    } finally {
      setIsLoading(false);
    }
  };

  // 🖨️ Imprimir QR
  const handlePrintQr = async () => {
    try {
      if (!printer) return alert("Seleccione una impresora primero.");

      const rawCommands = BackendQzPayloadAdapter.toRawEscPos(qrTestPayload);

      console.log("🔍 QR RAW:", rawCommands);

      await print(printer, rawCommands);

      alert(`✅ QR impreso correctamente en ${printer}`);
    } catch (err) {
      console.error("❌ Error al imprimir QR:", err);
      alert("Error al imprimir QR: " + (err as Error).message);
    }
  };

  return (
    <section className="rounded-sm border border-stroke bg-white shadow-default transition dark:border-strokedark dark:bg-boxdark">
      {/* === Header === */}
      <div className="flex items-center gap-2 border-b border-stroke px-4 py-3 dark:border-strokedark sm:px-5 xl:px-6">
        <QrCode className="h-5 w-5 text-primary" />
        <h3 className="font-semibold text-black dark:text-white">
          Prueba de Código QR
        </h3>
      </div>

      {/* === Body === */}
      <div className="p-4 sm:p-5 xl:p-6">
        <p className="text-gray-600 dark:text-gray-400 mb-4 text-sm">
          Estado:{" "}
          {isConnected ? (
            <span className="font-medium text-green-500">Conectado</span>
          ) : (
            <span className="text-red-500 font-medium">Desconectado</span>
          )}
        </p>

        {/* Botones */}
        <div className="flex flex-col gap-3">
          <button
            onClick={handleDiscoverPrinters}
            className="bg-primary hover:bg-primary/90 text-white px-4 py-2 rounded-md text-sm font-medium inline-flex items-center gap-2"
            disabled={isLoading}
          >
            <Printer className="h-4 w-4" />
            {isLoading ? "Buscando..." : "Buscar impresoras"}
          </button>

          <button
            onClick={handlePrintQr}
            disabled={!printer}
            className={`inline-flex items-center justify-center gap-2 rounded-md px-4 py-2 text-sm font-medium text-white transition ${
              printer
                ? "bg-indigo-600 hover:bg-indigo-700"
                : "bg-gray-400 cursor-not-allowed opacity-60"
            }`}
          >
            <QrCode className="h-4 w-4" />
            Imprimir SOLO Código QR
          </button>
        </div>
      </div>
    </section>
  );
};

export default PrintQrSection;
